import { trpc } from '@/shared/api';

interface InvalidateShippingFeeSettings {
  /** 배송비 설정을 다시 불러온다 — 재조회 promise 를 돌려준다. */
  readonly invalidate: () => Promise<void>;
}

/** 배송비 설정 다시 불러오기 — 쓰기 훅이 재조회 promise 를 기다려 새 값이 오기 전에 버튼이 풀리지 않게 한다. */
export const useInvalidateShippingFeeSettings = (): InvalidateShippingFeeSettings => {
  const utils = trpc.useUtils();
  return { invalidate: () => utils.shippingFeeSettings.get.invalidate() };
};
